import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface UseModalClosingParams {
  opened: boolean;
  closingDuration?: number;
}
export enum MODAL_CLOSING_STATE {
  CLOSED = 0,
  CLOSING = 1,
  OPENED = 2,
}
export const useModalClosing = t0 => {
  const $ = _c(7);
  const {
    opened,
    closingDuration
  } = t0;
  const [state, setState] = useState(opened ? MODAL_CLOSING_STATE.OPENED : MODAL_CLOSING_STATE.CLOSED);
  let t1;
  let t2;
  if ($[0] !== opened) {
    t1 = () => {
      if (opened) {
        setState(MODAL_CLOSING_STATE.OPENED);
      } else {
        setState(_temp);
      }
    };
    t2 = [opened];
    $[0] = opened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== closingDuration || $[4] !== state) {
    t3 = () => {
      if (state === MODAL_CLOSING_STATE.CLOSING) {
        const closeTimer = setTimeout(() => setState(MODAL_CLOSING_STATE.CLOSED), closingDuration);
        return () => clearTimeout(closeTimer);
      }
    };
    t4 = [state, closingDuration];
    $[3] = closingDuration;
    $[4] = state;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  return state;
};
function _temp(prev) {
  if (prev === MODAL_CLOSING_STATE.OPENED) {
    return MODAL_CLOSING_STATE.CLOSING;
  }
  return prev;
}